export const DropDown = ({ color = "#949494" }) => (
  <svg
    width="10"
    height="5"
    viewBox="0 0 10 5"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M0 0L5 5L10 0H0Z" fill={color} />
  </svg>
);

export const Search = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.5005 14H14.7105L14.4305 13.73C15.0554 13.0039 15.5122 12.1487 15.768 11.2256C16.0239 10.3024 16.0725 9.33413 15.9105 8.38998C15.4405 5.60998 13.1205 3.38997 10.3205 3.04997C9.33608 2.92544 8.33625 3.02775 7.39749 3.34906C6.45872 3.67038 5.60591 4.20219 4.90429 4.90381C4.20268 5.60542 3.67087 6.45824 3.34955 7.397C3.02823 8.33576 2.92593 9.33559 3.05046 10.32C3.39046 13.12 5.61046 15.44 8.39046 15.91C9.33462 16.072 10.3029 16.0234 11.2261 15.7675C12.1492 15.5117 13.0044 15.0549 13.7305 14.43L14.0005 14.71V15.5L18.2505 19.75C18.6605 20.16 19.3305 20.16 19.7405 19.75C20.1505 19.34 20.1505 18.67 19.7405 18.26L15.5005 14ZM9.50046 14C7.01046 14 5.00046 11.99 5.00046 9.49997C5.00046 7.00997 7.01046 4.99997 9.50046 4.99997C11.9905 4.99997 14.0005 7.00997 14.0005 9.49997C14.0005 11.99 11.9905 14 9.50046 14Z"
      fill="#878686"
    />
  </svg>
);

export const Filter = ({ color = "#8F8E8E" }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5 4H19L14 10.5V20L10 16V10.5L5 4Z"
      stroke={color}
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const Delete = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 21C6.45 21 5.97933 20.8043 5.588 20.413C5.19667 20.0217 5.00067 19.5507 5 19V6H4V4H9V3H15V4H20V6H19V19C19 19.55 18.8043 20.021 18.413 20.413C18.0217 20.805 17.5507 21.0007 17 21H7ZM17 6H7V19H17V6ZM9 17H11V8H9V17ZM13 17H15V8H13V17Z"
      fill="black"
    />
  </svg>
);

export const Edit = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 2.25H3.75C3.35218 2.25 2.97064 2.40804 2.68934 2.68934C2.40804 2.97064 2.25 3.35218 2.25 3.75V14.25C2.25 14.6478 2.40804 15.0294 2.68934 15.3107C2.97064 15.592 3.35218 15.75 3.75 15.75H14.25C14.6478 15.75 15.0294 15.592 15.3107 15.3107C15.592 15.0294 15.75 14.6478 15.75 14.25V9"
      stroke="black"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M13.7813 1.96868C14.0797 1.67031 14.4844 1.50269 14.9063 1.50269C15.3283 1.50269 15.733 1.67031 16.0313 1.96868C16.3297 2.26704 16.4973 2.67172 16.4973 3.09368C16.4973 3.51563 16.3297 3.92031 16.0313 4.21868L9.27157 10.9792C9.09348 11.1571 8.87347 11.2874 8.63182 11.3579L6.47707 11.9879C6.41253 12.0067 6.34412 12.0079 6.279 11.9912C6.21388 11.9745 6.15444 11.9406 6.10691 11.8931C6.05937 11.8456 6.02549 11.7861 6.0088 11.721C5.99212 11.6559 5.99325 11.5875 6.01207 11.5229L6.64207 9.36818C6.71297 9.12671 6.84347 8.90697 7.02157 8.72918L13.7813 1.96868Z"
      stroke="black"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const LocationIcon = ({ color = "#A19C9C", size = "10" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.99967 4.79159C4.72341 4.79159 4.45846 4.68184 4.2631 4.48649C4.06775 4.29114 3.95801 4.02619 3.95801 3.74992C3.95801 3.47365 4.06775 3.2087 4.2631 3.01335C4.45846 2.818 4.72341 2.70825 4.99967 2.70825C5.27594 2.70825 5.54089 2.818 5.73624 3.01335C5.93159 3.2087 6.04134 3.47365 6.04134 3.74992C6.04134 3.88671 6.0144 4.02217 5.96205 4.14855C5.9097 4.27493 5.83297 4.38976 5.73624 4.48649C5.63952 4.58322 5.52468 4.65994 5.3983 4.71229C5.27192 4.76464 5.13647 4.79159 4.99967 4.79159ZM4.99967 0.833252C4.22613 0.833252 3.48426 1.14054 2.93728 1.68752C2.3903 2.2345 2.08301 2.97637 2.08301 3.74992C2.08301 5.93742 4.99967 9.16658 4.99967 9.16658C4.99967 9.16658 7.91634 5.93742 7.91634 3.74992C7.91634 2.97637 7.60905 2.2345 7.06207 1.68752C6.51509 1.14054 5.77322 0.833252 4.99967 0.833252Z"
      fill={color}
    />
  </svg>
);

export const Phone = ({ color = "#000" }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.48578 1.54445L5.59264 1.21074C5.95794 1.10078 6.35076 1.12746 6.69784 1.2858C7.04492 1.44415 7.32254 1.72334 7.47892 2.07131L8.25492 3.79702C8.38961 4.09641 8.42715 4.43046 8.36227 4.75227C8.2974 5.07408 8.13336 5.36749 7.89321 5.59131L6.71206 6.69188C6.55378 6.84217 6.67378 7.42788 7.25206 8.43017C7.83092 9.43302 8.27835 9.8296 8.48464 9.76788L10.0321 9.29474C10.3457 9.1988 10.6816 9.20341 10.9925 9.30794C11.3034 9.41246 11.5738 9.61165 11.7658 9.8776L12.8686 11.4062C13.0914 11.7148 13.1945 12.0939 13.1589 12.4728C13.1233 12.8518 12.9513 13.205 12.6749 13.4667L11.8223 14.2742C11.5471 14.5348 11.2077 14.7178 10.8387 14.8044C10.4696 14.891 10.0842 14.8782 9.72178 14.7673C7.93549 14.2205 6.28121 12.5976 4.73664 9.9216C3.18864 7.2416 2.60406 4.98102 3.01149 3.13417C3.09367 2.76203 3.2736 2.41853 3.53275 2.1391C3.79189 1.85966 4.12088 1.65439 4.48578 1.54445Z"
      fill={color}
    />
  </svg>
);

export const AddressIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.333 2.66675H2.66634C1.93301 2.66675 1.33967 3.26675 1.33967 4.00008L1.33301 12.0001C1.33301 12.7334 1.93301 13.3334 2.66634 13.3334H13.333C14.0663 13.3334 14.6663 12.7334 14.6663 12.0001V4.00008C14.6663 3.26675 14.0663 2.66675 13.333 2.66675ZM13.0663 5.50008L8.35301 8.44675C8.13967 8.58008 7.85967 8.58008 7.64634 8.44675L2.93301 5.50008C2.86616 5.46256 2.80762 5.41186 2.76093 5.35105C2.71425 5.29025 2.68038 5.2206 2.66139 5.14633C2.6424 5.07206 2.63868 4.9947 2.65045 4.91895C2.66221 4.8432 2.68923 4.77062 2.72986 4.70562C2.77049 4.64061 2.82389 4.58452 2.88683 4.54074C2.94976 4.49697 3.02092 4.46642 3.096 4.45095C3.17109 4.43547 3.24853 4.43539 3.32364 4.45071C3.39876 4.46603 3.46998 4.49644 3.53301 4.54008L7.99967 7.33342L12.4663 4.54008C12.5294 4.49644 12.6006 4.46603 12.6757 4.45071C12.7508 4.43539 12.8283 4.43547 12.9033 4.45095C12.9784 4.46642 13.0496 4.49697 13.1125 4.54074C13.1755 4.58452 13.2289 4.64061 13.2695 4.70562C13.3101 4.77062 13.3371 4.8432 13.3489 4.91895C13.3607 4.9947 13.3569 5.07206 13.338 5.14633C13.319 5.2206 13.2851 5.29025 13.2384 5.35105C13.1917 5.41186 13.1332 5.46256 13.0663 5.50008Z"
      fill="#A2A1A8"
    />
  </svg>
);

export const Close = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.21934 5.21934C5.35997 5.07889 5.55059 5 5.74934 5C5.94809 5 6.13871 5.07889 6.27934 5.21934L18.2793 17.2193C18.353 17.288 18.4121 17.3708 18.4531 17.4628C18.4941 17.5548 18.5162 17.6541 18.5179 17.7548C18.5197 17.8555 18.5012 17.9555 18.4635 18.0489C18.4257 18.1423 18.3696 18.2272 18.2984 18.2984C18.2272 18.3696 18.1423 18.4257 18.0489 18.4635C17.9555 18.5012 17.8555 18.5197 17.7548 18.5179C17.6541 18.5162 17.5548 18.4941 17.4628 18.4531C17.3708 18.4121 17.288 18.353 17.2193 18.2793L5.21934 6.27934C5.07889 6.13871 5 5.94809 5 5.74934C5 5.55059 5.07889 5.35997 5.21934 5.21934Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.2789 5.21934C18.4193 5.35997 18.4982 5.55059 18.4982 5.74934C18.4982 5.94809 18.4193 6.13871 18.2789 6.27934L6.27887 18.2793C6.1367 18.4118 5.94865 18.4839 5.75435 18.4805C5.56005 18.4771 5.37466 18.3984 5.23725 18.261C5.09983 18.1235 5.02112 17.9382 5.01769 17.7439C5.01427 17.5496 5.08639 17.3615 5.21887 17.2193L17.2189 5.21934C17.3595 5.07889 17.5501 5 17.7489 5C17.9476 5 18.1382 5.07889 18.2789 5.21934Z"
      fill="black"
    />
  </svg>
);
export const EyeIcon = ({ color = "#000" }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.8285 9.7125L18.3472 9.4525V9.45L18.3435 9.44625L18.336 9.43125L18.3097 9.38125L18.2097 9.20125C18.0877 8.99076 17.958 8.78479 17.821 8.58375C17.3636 7.91244 16.8379 7.29036 16.2522 6.7275C14.8447 5.3775 12.6785 4 9.70347 4C6.73097 4 4.56347 5.37625 3.15597 6.7275C2.5703 7.29036 2.04457 7.91244 1.58722 8.58375C1.40165 8.85756 1.22977 9.14041 1.07222 9.43125L1.06472 9.44625L1.06222 9.45V9.45125C1.06222 9.45125 1.06097 9.4525 1.57972 9.7125L1.06097 9.45125C1.02087 9.53228 1 9.62147 1 9.71187C1 9.80228 1.02087 9.89147 1.06097 9.9725L1.05972 9.975L1.06347 9.97875L1.07097 9.99375C1.10995 10.0718 1.15164 10.1486 1.19597 10.2238C1.73422 11.133 2.39266 11.9655 3.15347 12.6987C4.56222 14.0487 6.72847 15.4237 9.70347 15.4237C12.6772 15.4237 14.8447 14.0487 16.2535 12.6975C16.8381 12.134 17.3633 11.512 17.821 10.8412C17.9962 10.5832 18.1593 10.3171 18.3097 10.0437L18.336 9.99375L18.3435 9.97875L18.346 9.975V9.97375C18.346 9.97375 18.3472 9.9725 17.8285 9.7125ZM17.8285 9.7125L18.3472 9.97375C18.3873 9.89272 18.4082 9.80353 18.4082 9.71312C18.4082 9.62271 18.3873 9.53353 18.3472 9.4525L17.8285 9.7125ZM9.62847 7.7925C9.11926 7.7925 8.6309 7.99479 8.27083 8.35486C7.91076 8.71492 7.70847 9.20328 7.70847 9.7125C7.70847 10.2217 7.91076 10.7101 8.27083 11.0701C8.6309 11.4302 9.11926 11.6325 9.62847 11.6325C10.1377 11.6325 10.626 11.4302 10.9861 11.0701C11.3462 10.7101 11.5485 10.2217 11.5485 9.7125C11.5485 9.20328 11.3462 8.71492 10.9861 8.35486C10.626 7.99479 10.1377 7.7925 9.62847 7.7925ZM6.55097 9.7125C6.55097 8.89563 6.87547 8.11222 7.45308 7.53461C8.0307 6.957 8.81411 6.6325 9.63097 6.6325C10.4478 6.6325 11.2312 6.957 11.8089 7.53461C12.3865 8.11222 12.711 8.89563 12.711 9.7125C12.711 10.5294 12.3865 11.3128 11.8089 11.8904C11.2312 12.468 10.4478 12.7925 9.63097 12.7925C8.81411 12.7925 8.0307 12.468 7.45308 11.8904C6.87547 11.3128 6.55097 10.5294 6.55097 9.7125Z"
      fill={color}
    />
  </svg>
);

export const Warning = () => (
  <svg
    width="21"
    height="28"
    viewBox="0 0 21 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.1304 6.71655L19.0784 20.4666C19.1895 20.6554 19.2145 20.861 19.1534 21.0832C19.0923 21.3054 18.9618 21.4777 18.7618 21.5999C18.6396 21.6777 18.5008 21.7166 18.3452 21.7166H2.48254C2.24926 21.7166 2.05209 21.6332 1.89102 21.4666C1.72995 21.2999 1.64941 21.1054 1.64941 20.8832C1.64941 20.7277 1.68274 20.5888 1.74939 20.4666L9.6974 6.71655C9.80849 6.51655 9.97511 6.386 10.1973 6.32489C10.4194 6.26377 10.6305 6.28877 10.8305 6.39989C10.9638 6.47766 11.0637 6.58322 11.1304 6.71655ZM3.91551 20.0499H16.9123L10.4139 8.79989L3.91551 20.0499ZM9.58076 17.5499H11.247V19.2166H9.58076V17.5499ZM9.58076 11.7166H11.247V15.8832H9.58076V11.7166Z"
      fill="#DC2626"
    />
  </svg>
);
export const ProfileIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 6.66667C8.30642 6.66667 8.60983 6.60631 8.89293 6.48905C9.17602 6.37179 9.43325 6.19992 9.64992 5.98325C9.86659 5.76658 10.0385 5.50935 10.1557 5.22626C10.273 4.94317 10.3333 4.63975 10.3333 4.33333C10.3333 4.02692 10.273 3.7235 10.1557 3.44041C10.0385 3.15731 9.86659 2.90009 9.64992 2.68342C9.43325 2.46675 9.17602 2.29488 8.89293 2.17761C8.60983 2.06035 8.30642 2 8 2C7.38116 2 6.78767 2.24583 6.35008 2.68342C5.9125 3.121 5.66667 3.71449 5.66667 4.33333C5.66667 4.95217 5.9125 5.54566 6.35008 5.98325C6.78767 6.42083 7.38116 6.66667 8 6.66667ZM2 13.6V14H14V13.6C14 12.1067 14 11.36 13.7093 10.7893C13.4537 10.2876 13.0457 9.87966 12.544 9.624C11.9733 9.33333 11.2267 9.33333 9.73333 9.33333H6.26667C4.77333 9.33333 4.02667 9.33333 3.456 9.624C2.95426 9.87966 2.54633 10.2876 2.29067 10.7893C2 11.36 2 12.1067 2 13.6Z"
      stroke="#296EAE"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const ClothIcon = ({ color = "#fff" }) => (
  <svg
    width="20"
    height="22"
    viewBox="0 0 20 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.03516 20.8867H14.0352V9.76669L17.0352 11.62L18.5352 5.13335L15.5352 0.5H13.2852C13.2852 1.42667 11.3352 3.28001 9.53516 3.28001C7.73516 3.28001 5.78516 1.42667 5.78516 0.5H3.53516L0.535156 5.13335L2.03516 11.62L5.03516 9.76669V20.8867Z"
      stroke={color}
    />
  </svg>
);

export const SecurityIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 1L3 5V11C3 16.55 6.84 21.74 12 23C17.16 21.74 21 16.55 21 11V5L12 1ZM19 11C19 15.52 16.02 19.69 12 20.93C7.98 19.69 5 15.52 5 11V6.3L12 3.19L19 6.3V11ZM7.41 11.59L6 13L10 17L18 9L16.59 7.58L10 14.17L7.41 11.59Z"
      fill="white"
    />
  </svg>
);

export const CheckedIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM16.59 7.58L10 14.17L7.41 11.59L6 13L10 17L18 9L16.59 7.58Z"
      fill="#10A242"
    />
  </svg>
);

export const LockIcon = () => (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 13.6667C2 11.3101 2 10.1309 2.7325 9.39925C3.46417 8.66675 4.64333 8.66675 7 8.66675H13.6667C16.0233 8.66675 17.2025 8.66675 17.9342 9.39925C18.6667 10.1309 18.6667 11.3101 18.6667 13.6667C18.6667 16.0234 18.6667 17.2026 17.9342 17.9342C17.2025 18.6667 16.0233 18.6667 13.6667 18.6667H7C4.64333 18.6667 3.46417 18.6667 2.7325 17.9342C2 17.2026 2 16.0234 2 13.6667Z"
      stroke="black"
      strokeWidth="1.5"
    />
    <path
      d="M5.33398 8.66667V7C5.33398 5.67392 5.86077 4.40215 6.79845 3.46447C7.73613 2.52678 9.0079 2 10.334 2C11.6601 2 12.9318 2.52678 13.8695 3.46447C14.8072 4.40215 15.334 5.67392 15.334 7V8.66667"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export const ShowMoreIcon = () => (
  <svg
    width="4"
    height="20"
    viewBox="0 0 4 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="2" cy="2" r="2" fill="black" />
    <circle cx="2" cy="10" r="2" fill="black" />
    <circle cx="2" cy="18" r="2" fill="black" />
  </svg>
);

//this icon is used in activity-log screen
export const ActionTypeIcon = ({ color = "#166534" }) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.28094 5.5V4L7.68094 6L5.28094 8V6.5H0.960938V5.5H5.28094ZM1.66174 7.5H2.67934C2.87134 7.98667 3.14494 8.42 3.50014 8.8C3.85534 9.18 4.26334 9.47333 4.72414 9.68C5.21054 9.89333 5.71614 10 6.24094 10C6.93854 10 7.58494 9.81667 8.18014 9.45C8.75614 9.09667 9.21374 8.62 9.55294 8.02C9.90494 7.4 10.0809 6.72667 10.0809 6C10.0809 5.27333 9.90494 4.6 9.55294 3.98C9.21374 3.38 8.75614 2.90333 8.18014 2.55C7.58494 2.18333 6.93854 2 6.24094 2C5.71614 2 5.21054 2.10667 4.72414 2.32C4.26334 2.52667 3.85534 2.82 3.50014 3.2C3.14494 3.58 2.87134 4.01333 2.67934 4.5H1.66174C1.86654 3.82667 2.19294 3.225 2.64094 2.695C3.08894 2.165 3.62014 1.75333 4.23454 1.46C4.86814 1.15333 5.53694 1 6.24094 1C6.89374 1 7.51774 1.13 8.11294 1.39C8.68254 1.64333 9.18974 2.00167 9.63454 2.465C10.0793 2.92833 10.4233 3.45667 10.6665 4.05C10.9161 4.67 11.0409 5.32 11.0409 6C11.0409 6.68 10.9161 7.33 10.6665 7.95C10.4233 8.54333 10.0793 9.07167 9.63454 9.535C9.18974 9.99833 8.68254 10.3567 8.11294 10.61C7.51774 10.87 6.89374 11 6.24094 11C5.53694 11 4.86814 10.8467 4.23454 10.54C3.62014 10.2467 3.08894 9.835 2.64094 9.305C2.19294 8.775 1.86654 8.17333 1.66174 7.5Z"
      fill={color}
    />
  </svg>
);

export const ActivityLogEyeIcon = ({ color = "#2563EB", size = "16" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.99902 2C9.12542 2 10.1921 2.26667 11.199 2.8C12.1633 3.31556 12.9761 4.02889 13.6374 4.94C14.2988 5.85111 14.7276 6.87111 14.9238 8C14.7276 9.12889 14.2988 10.1489 13.6374 11.06C12.9761 11.9711 12.1633 12.6844 11.199 13.2C10.1921 13.7333 9.12542 14 7.99902 14C6.87262 14 5.80595 13.7333 4.79902 13.2C3.83475 12.6844 3.02195 11.9711 2.36062 11.06C1.69929 10.1489 1.27049 9.12889 1.07422 8C1.27049 6.87111 1.69929 5.85111 2.36062 4.94C3.02195 4.02889 3.83475 3.31556 4.79902 2.8C5.80595 2.26667 6.87262 2 7.99902 2ZM7.99902 12.6667C8.88649 12.6667 9.73129 12.4622 10.5334 12.0533C11.31 11.6622 11.9692 11.1111 12.511 10.4C13.0529 9.68889 13.422 8.88889 13.6182 8C13.422 7.11111 13.0529 6.31111 12.511 5.6C11.9692 4.88889 11.31 4.33778 10.5334 3.94667C9.73129 3.53778 8.88649 3.33333 7.99902 3.33333C7.11155 3.33333 6.26675 3.53778 5.46462 3.94667C4.68809 4.33778 4.02889 4.88889 3.48702 5.6C2.94515 6.31111 2.57609 7.11111 2.37982 8C2.57609 8.88889 2.94515 9.68889 3.48702 10.4C4.02889 11.1111 4.68809 11.6622 5.46462 12.0533C6.26675 12.4622 7.11155 12.6667 7.99902 12.6667ZM7.99902 11C7.47849 11 6.99849 10.8644 6.55902 10.5933C6.11955 10.3222 5.76969 9.95778 5.50942 9.5C5.24915 9.04222 5.11902 8.54222 5.11902 8C5.11902 7.45778 5.24915 6.95778 5.50942 6.5C5.76969 6.04222 6.11955 5.67778 6.55902 5.40667C6.99849 5.13556 7.47849 5 7.99902 5C8.51955 5 8.99955 5.13556 9.43902 5.40667C9.87848 5.67778 10.2284 6.04222 10.4886 6.5C10.7489 6.95778 10.879 7.45778 10.879 8C10.879 8.54222 10.7489 9.04222 10.4886 9.5C10.2284 9.95778 9.87848 10.3222 9.43902 10.5933C8.99955 10.8644 8.51955 11 7.99902 11ZM7.99902 9.66667C8.28915 9.66667 8.55582 9.59111 8.79902 9.44C9.04222 9.28889 9.23635 9.08667 9.38142 8.83333C9.52649 8.58 9.59902 8.30222 9.59902 8C9.59902 7.69778 9.52649 7.42 9.38142 7.16667C9.23635 6.91333 9.04222 6.71111 8.79902 6.56C8.55582 6.40889 8.28915 6.33333 7.99902 6.33333C7.70889 6.33333 7.44222 6.40889 7.19902 6.56C6.95582 6.71111 6.76169 6.91333 6.61662 7.16667C6.47155 7.42 6.39902 7.69778 6.39902 8C6.39902 8.30222 6.47155 8.58 6.61662 8.83333C6.76169 9.08667 6.95582 9.28889 7.19902 9.44C7.44222 9.59111 7.70889 9.66667 7.99902 9.66667Z"
      fill={color}
    />
  </svg>
);

export const Loader = () => (
  <svg
    className="animate-spin h-5 w-5"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
  >
    <circle
      className="opacity-25"
      cx="12"
      cy="12"
      r="10"
      stroke="currentColor"
      strokeWidth="4"
    />
    <path
      className="opacity-75"
      fill="currentColor"
      d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
    />
  </svg>
);

export const AssignedVP = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
    <circle cx="9" cy="7" r="4"></circle>
    <line x1="19" x2="19" y1="8" y2="14"></line>
    <line x1="22" x2="16" y1="11" y2="11"></line>
  </svg>
);

export const AssignedVP2 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    class="lucide lucide-shield-check w-3 h-3"
    aria-hidden="true"
  >
    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
    <path d="m9 12 2 2 4-4"></path>
  </svg>
);

export const Incharge = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    class="lucide lucide-briefcase w-3 h-3"
    aria-hidden="true"
  >
    <path d="M16 20V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
    <rect width="20" height="14" x="2" y="6" rx="2"></rect>
  </svg>
);

export const Building = () => (
  <svg
    width="14"
    height="12"
    viewBox="0 0 14 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.6 3.35606V10.0368H11.2V5.0184H2.8V10.0368H1.4V3.35606L7 1.3487L12.6 3.35606ZM14 11.2914V2.5092L7 0L0 2.5092V11.2914H4.2V6.273H9.8V11.2914H14ZM6.3 10.0368H4.9V11.2914H6.3V10.0368ZM7.7 8.1549H6.3V9.4095H7.7V8.1549ZM9.1 10.0368H7.7V11.2914H9.1V10.0368Z"
      fill="#147578"
    />
  </svg>
);

export const SupplierIcon = () => (
  <svg
    width="14"
    height="13"
    viewBox="0 0 14 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.60052 6.15194C6.70196 6.25136 6.80896 6.34483 6.92151 6.43236C7.09895 6.58311 7.27638 6.70144 7.43085 6.85219C7.44928 6.87469 7.47316 6.89272 7.50049 6.90478C7.52782 6.91684 7.55782 6.92258 7.58799 6.92152C7.61816 6.92047 7.64762 6.91264 7.67393 6.8987C7.70023 6.88476 7.72261 6.86511 7.73921 6.84139C7.75891 6.81205 7.76844 6.77769 7.76649 6.74304C7.76454 6.70838 7.75119 6.67516 7.7283 6.64795C7.62359 6.44645 7.50103 6.25359 7.36195 6.07143C7.30139 5.99463 7.23438 5.92253 7.16154 5.85584C7.0903 5.78581 7.01181 5.72264 6.92725 5.66727L6.77795 5.58622C7.15723 5.24905 7.44863 4.83401 7.62941 4.37346C7.81019 3.9129 7.87548 3.41928 7.82018 2.93108C7.69959 1.41169 6.60626 -0.0266414 4.66019 0.000374655C2.41036 0.0706165 1.16198 1.54083 1.11088 3.01159C1.08878 3.59187 1.26091 4.16403 1.60298 4.64731C1.94504 5.13059 2.43976 5.50059 3.01732 5.70509C2.49989 5.99701 2.01289 6.33423 1.5628 6.71225C1.1912 7.01294 0.863872 7.35891 0.589476 7.74102C0.346337 8.06245 0.173125 8.42593 0.0798001 8.81057C-0.0135243 9.19521 -0.0251198 9.59341 0.0456806 9.98228C0.0510978 10.0059 0.0615792 10.0283 0.0764861 10.048C0.0913929 10.0678 0.110413 10.0844 0.132387 10.097C0.154362 10.1096 0.17883 10.1179 0.204301 10.1213C0.229772 10.1247 0.255712 10.1232 0.280541 10.1168C0.327635 10.1089 0.369793 10.0845 0.398551 10.0485C0.427309 10.0125 0.440538 9.96762 0.435583 9.92284C0.40753 9.24258 0.648084 8.57662 1.11088 8.05333C1.37349 7.71761 1.66156 7.4017 1.97509 7.1056C2.43956 6.66077 2.9328 6.24339 3.45201 5.85584C3.79253 5.94229 4.14166 5.99308 4.49424 6.00713C4.51578 6.00852 4.53739 6.00581 4.5578 5.99917C4.5782 5.99253 4.59697 5.98209 4.613 5.96848C4.62902 5.95486 4.64197 5.93835 4.65106 5.91993C4.66016 5.90151 4.66522 5.88155 4.66594 5.86124C4.66762 5.82143 4.65312 5.7825 4.62538 5.75239C4.59765 5.72228 4.55876 5.70324 4.51664 5.69915C2.52463 5.54353 1.61448 4.3478 1.65467 3.12992H1.70061C1.97803 3.25091 2.27691 3.32236 2.58205 3.34064C2.71145 3.35361 2.84122 3.35361 2.97138 3.34064C3.09987 3.32275 3.22635 3.29382 3.34923 3.25419C3.64553 3.1541 3.91362 2.99166 4.13305 2.77925C4.15782 2.75057 4.17181 2.71499 4.17285 2.67805C4.17389 2.64111 4.16191 2.60488 4.13879 2.57501C4.28618 2.65822 4.43892 2.7317 4.59703 2.79546C4.87323 2.91757 5.16322 3.00997 5.46124 3.07048C6.07281 3.18036 6.69941 3.19497 7.31601 3.11371C7.40214 4.62175 6.4805 5.69374 5.16954 5.8607C5.12744 5.87168 5.09088 5.89641 5.06641 5.93045C5.04194 5.9645 5.03115 6.00563 5.03599 6.04648C5.04083 6.08733 5.06098 6.12522 5.09281 6.15335C5.12465 6.18149 5.1661 6.19804 5.20973 6.20003C5.61237 6.17077 6.00326 6.05862 6.35475 5.87151C6.4294 5.96877 6.50921 6.06008 6.60052 6.1514M3.87637 2.52098C3.70063 2.61888 3.50607 2.68315 3.30386 2.71009C3.20624 2.71009 3.10862 2.71009 3.00584 2.75331L2.55966 2.81275C2.30658 2.85539 2.04949 2.87332 1.79249 2.86624C1.77383 2.85723 1.75316 2.85253 1.73219 2.85253C1.71122 2.85253 1.69056 2.85723 1.6719 2.86624C1.72372 2.51351 1.85218 2.1746 2.04927 1.87063C2.24636 1.56665 2.50786 1.30412 2.81749 1.09939C3.06017 1.57098 3.40295 1.99079 3.82469 2.33294C3.89934 2.39238 3.97973 2.44101 4.05955 2.49504C4.0293 2.48309 3.99613 2.47924 3.96371 2.48392C3.93128 2.48859 3.90086 2.5016 3.87579 2.52152M5.59274 2.52152C5.08351 2.38064 4.60211 2.16255 4.1675 1.87583C3.75962 1.61398 3.40489 1.2855 3.12011 0.905954C3.60416 0.687825 4.13501 0.577276 4.67168 0.582841C6.18822 0.534212 7.06449 1.5954 7.27638 2.76466C6.71227 2.76642 6.15096 2.68995 5.61054 2.53773L5.59274 2.52152Z"
      fill="#147578"
    />
    <path
      d="M4.82105 7.02443C4.82557 7.00187 4.82474 6.97865 4.81864 6.95642C4.81253 6.9342 4.80129 6.91351 4.78572 6.89584C4.77015 6.87817 4.75062 6.86394 4.72854 6.85418C4.70646 6.84442 4.68236 6.83936 4.65797 6.83936C4.63357 6.83936 4.60947 6.84442 4.58739 6.85418C4.56531 6.86394 4.54579 6.87817 4.53022 6.89584C4.51464 6.91351 4.5034 6.9342 4.4973 6.95642C4.49119 6.97865 4.49037 7.00187 4.49489 7.02443C4.43746 7.29945 4.3743 7.56313 4.33984 7.85436V8.57083C4.36856 8.85072 4.42024 9.10953 4.46043 9.40022C4.46207 9.44782 4.48328 9.49295 4.5196 9.52611C4.55591 9.55928 4.60449 9.57787 4.6551 9.57799C4.70415 9.57645 4.75066 9.55706 4.78483 9.5239C4.81899 9.49075 4.83815 9.44641 4.83828 9.40022C4.86699 9.12034 4.90718 8.86152 4.93015 8.57083V7.86517C4.90718 7.56853 4.8555 7.29945 4.82105 7.02443Z"
      fill="#0C6FFF"
    />
    <path
      d="M13.1839 8.31199C13.2752 8.25256 13.3551 8.18772 13.378 8.17205C13.4986 8.07494 13.5964 7.95538 13.6654 7.8209C13.7344 7.68643 13.773 7.53996 13.7788 7.39074C13.7977 7.09869 13.6998 6.81056 13.5044 6.58296C13.3801 6.44807 13.2331 6.33342 13.0691 6.24364C12.9988 6.20191 12.9239 6.16749 12.8457 6.14098C12.7662 6.11265 12.6836 6.09271 12.5994 6.08154C12.4656 6.051 12.3265 6.04773 12.1913 6.07196C12.0561 6.09619 11.928 6.14736 11.8156 6.22203C11.6986 6.32169 11.6015 6.44027 11.529 6.57215C11.4754 6.67085 11.4086 6.76073 11.3286 6.84177C11.2792 6.80492 11.2276 6.77065 11.1741 6.73911L10.3214 5.95241C10.2904 5.92466 10.2493 5.90918 10.2066 5.90918C10.1638 5.90918 10.1227 5.92466 10.0917 5.95241C10.0769 5.97313 10.0637 5.9948 10.0521 6.01724C10.0229 6.00009 9.98918 5.991 9.95476 5.991C9.92035 5.991 9.88662 6.00009 9.85743 6.01724C9.72536 6.12531 9.25047 6.45382 8.99896 6.69589C8.89968 6.7802 8.8263 6.88806 8.78649 7.00819C8.78075 7.06493 8.7951 7.12166 8.82669 7.17029C8.87837 7.25674 9.05638 7.41235 9.09083 7.47179C9.18788 7.63551 9.2275 7.82408 9.20453 8.01049C9.20255 8.08455 9.17454 8.15591 9.12488 8.2134C9.07521 8.27088 9.0067 8.31126 8.93005 8.3282C8.82963 8.34401 8.72652 8.33277 8.6326 8.29578C8.45514 8.22607 8.28768 8.13567 8.13417 8.0267C8.03116 7.94021 7.92007 7.86263 7.80226 7.7949C7.72075 7.75083 7.62458 7.73733 7.53295 7.75708C7.28642 7.81779 7.05663 7.92759 6.85909 8.07907C6.66155 8.23055 6.50088 8.42016 6.38793 8.6351C6.26209 8.87244 6.21297 9.13928 6.24666 9.40261C6.28034 9.66594 6.39534 9.9142 6.57743 10.1167C7.06633 10.7547 7.62442 11.3433 8.2427 11.8727C8.68002 12.2333 9.19326 12.503 9.7489 12.6643C9.97917 12.7183 10.2226 12.6875 10.4299 12.5784C10.7842 12.3808 11.103 12.1317 11.3745 11.8403C11.5009 11.7067 11.6192 11.5667 11.7294 11.4205C11.776 11.357 11.7976 11.2802 11.7902 11.2034C11.7829 11.1266 11.7471 11.0547 11.6892 11.0001C11.5317 10.878 11.4013 10.7278 11.3056 10.5581C11.2746 10.5064 11.2617 10.4467 11.2689 10.3877C11.2762 10.3287 11.3031 10.2733 11.3458 10.2296C11.3951 10.1884 11.4537 10.1582 11.5172 10.1414C11.5806 10.1246 11.6473 10.1215 11.7122 10.1323C11.8942 10.1491 12.0711 10.1983 12.233 10.2782C12.3019 10.3052 12.4851 10.4457 12.5822 10.483C12.643 10.51 12.7102 10.5208 12.7774 10.5154C12.8717 10.4975 12.9577 10.4521 13.0232 10.3857C13.1116 10.2917 13.1937 10.193 13.2695 10.0896C13.4791 9.87892 13.6043 9.60714 13.6244 9.31915C13.6071 9.03567 13.4881 8.76611 13.2867 8.5546C13.2695 8.50056 13.2184 8.40331 13.1839 8.31199ZM12.5649 8.42005C12.6618 8.57279 12.7724 8.71633 12.8968 8.85069C13.0203 8.97875 13.0949 9.14192 13.1087 9.31375C13.0845 9.48225 12.9972 9.63708 12.8624 9.75033L12.7073 9.92809C12.5646 9.79728 12.3937 9.69687 12.2062 9.63366C12.0186 9.57046 11.8188 9.54593 11.6203 9.56175C11.3615 9.56407 11.1143 9.66299 10.933 9.83678C10.8254 9.9365 10.7479 10.0614 10.7087 10.1986C10.6694 10.3359 10.6697 10.4805 10.7096 10.6175C10.7946 10.8704 10.9439 11.1001 11.1449 11.2854C11.0832 11.3394 11.0183 11.3898 10.9502 11.4367C10.7886 11.6153 10.6093 11.7769 10.4121 11.9213C10.2571 12.0348 10.0975 12.1472 9.94873 12.1045C9.46968 11.9622 9.02842 11.7253 8.65442 11.4097C8.05899 10.9228 7.51654 10.3815 7.03509 9.79355C6.91757 9.67286 6.83812 9.52373 6.80566 9.36291C6.7732 9.20209 6.78902 9.03594 6.85134 8.88311C6.92332 8.74084 7.02545 8.61392 7.15145 8.51013C7.27745 8.40635 7.42466 8.32789 7.58405 8.27957C7.8637 8.47409 8.16747 8.63456 8.48847 8.75938C8.67222 8.82368 8.8709 8.83502 9.06097 8.7918C9.19733 8.76637 9.32332 8.70536 9.42456 8.61573C9.5258 8.52611 9.5982 8.41149 9.63348 8.28497C9.71736 7.95938 9.66406 7.61588 9.48476 7.32644C9.45604 7.28322 9.31249 7.13193 9.24415 7.06223C9.32569 6.97902 9.41355 6.90175 9.50772 6.83043C9.74833 6.62619 10.0343 6.4106 10.1371 6.32955C10.1646 6.30871 10.1846 6.28042 10.1945 6.2485L10.8928 6.96551C10.9732 7.0498 11.0593 7.12869 11.1512 7.20217C11.1853 7.22266 11.225 7.23355 11.2654 7.23355C11.3059 7.23355 11.3456 7.22266 11.3797 7.20217C11.7518 7.00333 11.792 6.66347 12.0378 6.49651C12.1112 6.45773 12.1922 6.43342 12.2759 6.42506C12.3597 6.4167 12.4443 6.42446 12.5247 6.44788C12.5783 6.45508 12.6298 6.46949 12.6792 6.49111C12.7309 6.51056 12.7806 6.53397 12.8285 6.56135L12.9996 6.68562L13.1489 6.83043C13.2695 6.9855 13.3212 7.17894 13.2919 7.36913C13.2895 7.45448 13.2672 7.5383 13.2266 7.61467C13.1861 7.69104 13.1282 7.75809 13.057 7.81111C12.9322 7.86478 12.8044 7.91161 12.6735 7.9516C12.6273 7.97107 12.5864 8 12.5537 8.03627C12.5211 8.07255 12.4974 8.11525 12.4845 8.16124C12.4746 8.25086 12.4947 8.34116 12.542 8.41951L12.5649 8.42005Z"
      fill="#147578"
    />
  </svg>
);
